export const filterLabel = {
  default: '',
  created_at_gteq: 'Data de criação inicial',
  created_at_lteq: 'Data de criação final',
  city_id_eq: 'Cidade',
  product_id_eq: 'Produto',
  client_branch_id_eq: 'Filial',
  with_branch_and_descendants_is: 'Filiais a baixo dessa também',
  client_equipment_id_eq: 'Equipamento',
};
